<template>
  <div>
    <b-img :src="photo" alt="equipment image" fluid-grow />
    <div class="position-absolute" style="right: 5px; bottom: 0px">
      <router-link
        class="nav-link"
        :to="{ name: boxSettingsRoutName, params: { boxId: deviceId } }"
      >
        <b-btn variant="dark" class="btn-icon" style="width: 28px; height: 28px">
          <i class="mdi mdi-settings btn-icon-prepend"></i>
        </b-btn>
      </router-link>
    </div>
  </div>
</template>
<script>
import boxInfoPhoto from '@/api/boxinfo/boxInfoPhoto.gql';
import defaultBoxImage from '@/assets/images/KOEEBOX.png';
import defaultProImage from '@/assets/images/koeebox-pro.png';

export default {
  name: 'BoxInfoPhoto',
  props: {
    deviceId: { type: String, required: true },
    imageUrl: { type: String, required: true },
    modelCodeBox: { type: String, required: true },
  },
  data() {
    return {
      boxSettingsRoutName: 'SettingsBox',
      modelCodePro: 'PRO',
    };
  },
  computed: {
    photo() {
      if (this.isUserAuthenticated) {
        return this.imageUrl
          ? this.imageUrl
          : this.modelCodeBox == this.modelCodePro
          ? defaultProImage
          : defaultBoxImage;
      }
      return this.boxPhoto
        ? this.boxPhoto
        : this.modelCodeBox == this.modelCodePro
        ? defaultProImage
        : defaultBoxImage;
    },
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated;
    },
  },
  apollo: {
    boxPhoto: {
      query() {
        return boxInfoPhoto;
      },
      variables() {
        return {
          deviceId: this.deviceId,
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.boxPhoto) {
          return queryData.boxPhoto;
        } else {
          return '';
        }
      },
      skip() {
        return this.$authCore.isAuthenticated;
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
};
</script>

<style></style>
